<div class="wa-stack">
  <div class="wa-heading-l">Corrections assigned</div>
  @if (corrections.length === 0) {
    <wa-callout variant="success">
      <wa-icon slot="icon" name="face-smile" variant="regular"></wa-icon>
      There are currently no supervisions assigned.
    </wa-callout>
  } @else {
    <div class="wa-grid">
      @for (assignment of corrections; track assignment.id) {
        <app-survey-correction-list-element
          [exam]="assignment.exam">
        </app-survey-correction-list-element>
      }
    </div>
  }
</div>
